// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"65a1481a","124":"bebf81e8","246":"8d14ee14","458":"98de8583","684":"88de0fb9","835":"a67e0be2","858":"5fb258f5"}[chunkId] + ".chunk.js";
};